import React, { FC } from 'react'
import * as yup from 'yup'
import { Formik, FormikProps, FormikHelpers } from 'formik'

import BaseInput from 'components/Input'
import Button from 'components/Button'
import BaseForm from 'components/Form'
import Modal from 'components/Modal'

/*
TODO: Use the correct types when this components update to Typescript
https://github.com/sketch-hq/Cloud/issues/1690
*/
const Form = BaseForm as any
const Input = BaseInput as any

const FORM_INITIAL_VALUES = {
  projectName: '',
}

interface FormValues {
  projectName: string
}

type FormActions = FormikHelpers<FormValues>

type FormOnSubmit = (
  formValues: FormValues,
  formikActions: FormActions
) => Promise<any>

interface AddNewProjectModalProps {
  onCancel: () => void
  onSubmit: FormOnSubmit
}

const newProjectFormSchema = yup.object({
  projectName: yup.string().trim().required('A project name is required'),
})

const AddNewProjectModal: FC<AddNewProjectModalProps> = props => {
  const { onSubmit, onCancel } = props
  const handleFormikRender = (formikBag: FormikProps<FormValues>) => {
    const {
      errors,
      values,
      touched,
      handleBlur,
      handleChange,
      handleSubmit,
      isSubmitting,
    } = formikBag

    return (
      <Modal title="Create a New Project" onCancel={onCancel}>
        <Form onSubmit={handleSubmit}>
          <Modal.Body>
            <Form.Field
              name="projectName"
              label="Project Name"
              errorText={touched.projectName && errors.projectName}>
              <Input
                name="projectName"
                type="text"
                placeholder="Give your project a name"
                value={values.projectName}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={isSubmitting}
                autoFocus
              />
            </Form.Field>
          </Modal.Body>
          <Modal.Footer>
            <Button disabled={isSubmitting} type="button" onClick={onCancel}>
              Cancel
            </Button>
            <Button loading={isSubmitting} type="submit" variant="primary">
              Create Project
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    )
  }

  const handleOnSubmit = async (
    values: FormValues,
    formikActions: FormActions
  ) => {
    const trimmedValues = newProjectFormSchema.cast(values)

    formikActions.setSubmitting(true)

    try {
      await onSubmit(trimmedValues, formikActions)
    } catch (error) {
      // Ignore this error the mutation will handle it
    } finally {
      formikActions.setSubmitting(false)
    }
  }

  return (
    <Formik
      initialValues={FORM_INITIAL_VALUES}
      onSubmit={handleOnSubmit}
      validationSchema={newProjectFormSchema}
      validateOnBlur={false}>
      {handleFormikRender}
    </Formik>
  )
}

export default AddNewProjectModal
